import React from 'react';

const SearchFormWrapper = ({ children, icon, onClick, flexGrow = 1, flexShrink = 1 }) => {
  return (
    <div className="col-12 col-md mb-2 mb-md-0 px-0 mr-2" style={{ flexGrow, flexShrink }}>
      <div
        className="d-flex align-items-center p-2 bg-white rounded"
        style={{ cursor: 'pointer', width: '100%' }}
        onClick={onClick}
      >
        {icon && <div className="mr-2">{icon}</div>}
        {children}
      </div>
    </div>
  );
};

export default SearchFormWrapper;
